import { render, staticRenderFns } from "./RevokeDeviceTraitedDataDialogComponent.vue?vue&type=template&id=0823b6b7&"
import script from "./RevokeDeviceTraitedDataDialogComponent.vue?vue&type=script&lang=js&"
export * from "./RevokeDeviceTraitedDataDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports